<template>
  <v-dialog v-model="visible" max-width="400" persistent>
    <v-card>
      <v-toolbar color="secondary" flat density="compact">
        <v-toolbar-title>
          <v-icon class="text-accent mr-4">mdi-delete</v-icon>
          <span class="text-h6 text-accent"
            >{{$t("common.dialogs.confirmRemove.title", [ itemName ])}}</span
          ></v-toolbar-title
        >
        <v-btn icon variant="text" @click="onCancel">
          <v-icon class="text-accent">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-6">
        <p class="text-subtitle-1 text-accent">
          {{$t("common.dialogs.confirmRemove.confirm", [itemName])}}
        </p>
        <p class="text-caption text-accent">{{$t("common.dialogs.confirmRemove.note")}}</p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          v-if="confirmRemoveEvent !== undefined"
          class="mr-2 mb-2"
          @click.stop="
            $emit(confirmRemoveEvent);
            visible = false
          "
          >{{$t("common.actions.yes")}}</v-btn
        >
        <v-btn v-else class="mr-2 mb-2" @click.stop="onRemove">{{$t("common.actions.yes")}}</v-btn>
        <v-btn class="mr-2 mb-2" @click.stop="onCancel">{{$t("common.actions.no")}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["itemName", "item", "removeAction", "confirmRemoveEvent", "show"],
  emits: ["close"],
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.show
      },
      set(value) {
        if (!value) {
          this.$emit("close")
        }
      }
    }
  },
  methods: {
    onRemove() {
      this.$store.dispatch(this.removeAction, this.item)
      this.visible = false
    },
    onCancel() {
      this.visible = false
    }
  }
}
</script>
